import type { AfricanMarket } from '@/types/portal';

/**
 * Every African market the network can operate in, paired with the currency it
 * settles in. Powers the searchable market pickers and the currency options that
 * follow the markets a user selects.
 */
export const africanMarkets: AfricanMarket[] = [
  { name: 'Algeria', currency: 'DZD' },
  { name: 'Angola', currency: 'AOA' },
  { name: 'Benin', currency: 'XOF' },
  { name: 'Botswana', currency: 'BWP' },
  { name: 'Burkina Faso', currency: 'XOF' },
  { name: 'Burundi', currency: 'BIF' },
  { name: 'Cabo Verde', currency: 'CVE' },
  { name: 'Cameroon', currency: 'XAF' },
  { name: 'Central African Republic', currency: 'XAF' },
  { name: 'Chad', currency: 'XAF' },
  { name: 'Comoros', currency: 'KMF' },
  { name: 'Congo (Brazzaville)', currency: 'XAF' },
  { name: "Côte d'Ivoire", currency: 'XOF' },
  { name: 'DR Congo', currency: 'CDF' },
  { name: 'Djibouti', currency: 'DJF' },
  { name: 'Egypt', currency: 'EGP' },
  { name: 'Equatorial Guinea', currency: 'XAF' },
  { name: 'Eritrea', currency: 'ERN' },
  { name: 'Eswatini', currency: 'SZL' },
  { name: 'Ethiopia', currency: 'ETB' },
  { name: 'Gabon', currency: 'XAF' },
  { name: 'Gambia', currency: 'GMD' },
  { name: 'Ghana', currency: 'GHS' },
  { name: 'Guinea', currency: 'GNF' },
  { name: 'Guinea-Bissau', currency: 'XOF' },
  { name: 'Kenya', currency: 'KES' },
  { name: 'Lesotho', currency: 'LSL' },
  { name: 'Liberia', currency: 'LRD' },
  { name: 'Libya', currency: 'LYD' },
  { name: 'Madagascar', currency: 'MGA' },
  { name: 'Malawi', currency: 'MWK' },
  { name: 'Mali', currency: 'XOF' },
  { name: 'Mauritania', currency: 'MRU' },
  { name: 'Mauritius', currency: 'MUR' },
  { name: 'Morocco', currency: 'MAD' },
  { name: 'Mozambique', currency: 'MZN' },
  { name: 'Namibia', currency: 'NAD' },
  { name: 'Niger', currency: 'XOF' },
  { name: 'Nigeria', currency: 'NGN' },
  { name: 'Rwanda', currency: 'RWF' },
  { name: 'São Tomé and Príncipe', currency: 'STN' },
  { name: 'Senegal', currency: 'XOF' },
  { name: 'Seychelles', currency: 'SCR' },
  { name: 'Sierra Leone', currency: 'SLE' },
  { name: 'Somalia', currency: 'SOS' },
  { name: 'South Africa', currency: 'ZAR' },
  { name: 'South Sudan', currency: 'SSP' },
  { name: 'Sudan', currency: 'SDG' },
  { name: 'Tanzania', currency: 'TZS' },
  { name: 'Togo', currency: 'XOF' },
  { name: 'Tunisia', currency: 'TND' },
  { name: 'Uganda', currency: 'UGX' },
  { name: 'Zambia', currency: 'ZMW' },
  { name: 'Zimbabwe', currency: 'ZWL' },
];